<div *ngIf="showDatedBrowserAlert" class="text-center dated-browser-component p-3">
	Your browser is out of date. Update your browser for a more secure PayHOA experience.
</div>
